module.exports = __webpack_public_path__ + "img/IMG_1401_L_Foamcore_MockedUp.f26fb7cb.jpg";